module.exports = __webpack_public_path__ + "img/House.64e517b1.svg";